import styled from "styled-components";
import Input from "../../Input";

export const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
`
export const StyledInput = styled(Input)`
    margin: 2.5%;
`